<div>
    <ng-container *ngIf="!ngControl.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="always" color="accent" style="width: 100%;">
            <mat-select class="multiple-selection" [formControl]="ngControl.control" [placeholder]="placeholder" multiple   (openedChange)="onChangeOpen($event)">
                <input *ngIf="filterEnabled" #selectFilterInput
                    placeholder="{{'INPUT.SELECT-FILTER' | translate}}" 
                    class="select-filter" 
                    (keydown)="$event.stopPropagation()"
                    (keyup)="onFilterSelectKeyUp($event)">
                <!-- CLOSED CONTROL -->
                <mat-select-trigger>                            
                    <div class="multiple-selection-item">
                        <mat-chip-grid>
                            <mat-chip-row *ngFor="let selectedItemId of ngControl.value" class="chip-item" color="accent" selected>
                                {{ getItemDescription(selectedItemId) | translate }}
                            </mat-chip-row>
                        </mat-chip-grid>
                    </div>
                </mat-select-trigger>
                <mat-option *ngFor="let item of filteredItemsData"
                    [value]="item.id">
                    {{item.description | translate}}
                </mat-option>
            </mat-select>             
        </mat-form-field> 
        <!-- errors -->
        <ng-container *ngIf="ngControl.touched">
            <mat-error *ngIf="ngControl.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>
        </ng-container> 
    </ng-container>

    <ng-container *ngIf="ngControl.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <mat-chip-grid>
            <mat-chip-row *ngFor="let id of value" style="font-weight: bold;">{{items|getById:id:'description'}}</mat-chip-row>
        </mat-chip-grid>
    </ng-container>
</div>


<!-- <mat-select [formControlName]="evaluationFormControlName" class="multiple-selection" 
    (selectionChange)="removeMultipleSelectionNullValue()" multiple>

    <mat-select-trigger>                            
        <div *ngFor="let selectedItem of evaluationFormGroup.get(evaluationFormControlName).value" class="multiple-selection-item">                                
            <div *ngIf="selectedItem.id != null">
                <i class="material-icons md-24" style="margin-right: 0.3em;">check_box</i>
                <span>{{ selectedItem.description | trim}}</span>  
            </div>
            <div *ngIf="selectedItem.id == null">
                <i class="material-icons md-24" style="margin-right: 0.3em;">close</i>
                <span>{{ 'EVALUATION.MULTIPLE_SELECTION_ITEM_NO_SELECTION' | translate }}</span>  
            </div>          
        </div>
    </mat-select-trigger>
    
    <mat-option *ngFor="let answer of answers" [value]="answer.id">
        {{answer.description}}
    </mat-option>
    <mat-option [value]="getNoSelectionItem()" [disabled]="!nullSelectionEnabled()">
        {{ 'EVALUATION.MULTIPLE_SELECTION_ITEM_NO_SELECTION' | translate }}
    </mat-option>
</mat-select> -->
